import { EPFlagComponent } from './ep-flag';
import { createRender } from './types';
import { MESSAGE_ID, PRIMARY_ACTION_DATA_URL, TRIGGER } from '../../../ep-config';
import { formattedMessages } from '../../../formatted-messages';

/**
 * ⚠️  CRITICAL SAFETY WARNING FOR POST OFFICE MESSAGES ⚠️
 *
 * Messages in Post Office can go live and reach customers very easily, particularly
 * with implicit message creation. Before merging this code, ensure you have:
 *
 * 1. ✅ Set up a Statsig filter to control message visibility
 *    📖 https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#statsig-filter
 *
 * 2. ✅ Set up an environment filter to prevent accidental production deployment
 *    📖 https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#environment-filter
 *
 * 3. ✅ If using implicit messages, configure them properly in implicit-messages
 *    📖 https://developer.atlassian.com/platform/post-office/message-template/implicit-messages/#what-are-implicit-messages
 *
 * 4. ✅ Verify that you're not rendering anything you dont want customers to see.
 *    📖 https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/213556
 *
 * Remember: Test thoroughly in staging environments before enabling in production!
 */

export const render = createRender(
	({ onDismissed, messageInstanceId, userId, tenantId, locale }) => {
		return (
			<EPFlagComponent
				onDismiss={() => onDismissed(messageInstanceId)}
				messageId={MESSAGE_ID}
				primaryActionDataUrl={PRIMARY_ACTION_DATA_URL}
				trigger={TRIGGER}
				formattedMessages={formattedMessages}
				userId={userId}
				tenantId={tenantId}
				locale={locale}
			/>
		);
	},
);

export default render;
